import React from "react";
import favIco from "../../assets/img/fav_icon.png";

// In-page loader for lists and forms: a gold ring around the brand mark.
export default function ComponentsLoader() {
  return (
    <div className="avc-loader" role="status" aria-live="polite">
      <span className="avc-loader__ring">
        <img className="avc-loader__mark" src={favIco} alt="" />
      </span>
      <span className="avc-sr-only">Loading</span>
    </div>
  );
}
